import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {colorMetadata, fontMetadata} from '../../../utils/builderMetadata'

export type LinkStylesParams = {
  linkFont: StyleParamType.Font
  linkColor: StyleParamType.Color
}

export const linkStylesParams = createStylesParams<LinkStylesParams>({
  linkFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      style: {bold: false, italic: false, underline: true},
    }),
    metadata: fontMetadata('Body-M', 16),
  },
  linkColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: colorMetadata(StyleType.color, 'color-8', 1),
  },
})
